import { render } from "./DatasetTableViewBenchmarksSelectorPannel.vue?vue&type=template&id=7585c3c8"
import script from "./DatasetTableViewBenchmarksSelectorPannel.vue?vue&type=script&lang=js"
export * from "./DatasetTableViewBenchmarksSelectorPannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__